var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('MaintenancePanelMolecule', {
    attrs: {
      "title": _vm.$t('maintenance.hourMeter'),
      "badge": _vm.$t('maintenance.badgeText', {
        x: _vm.badgeCount
      })
    },
    scopedSlots: _vm._u([{
      key: "main",
      fn: function fn() {
        return [_c('HourMeterChartMolecule', {
          attrs: {
            "isLoading": _vm.$apollo.loading,
            "hourMeterData": _vm.hourMeterData,
            "durationTag": _vm.durationTag,
            "engineHoursAssetDimension": _vm.engineHoursAssetDimension
          }
        })];
      },
      proxy: true
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }